module.exports = __webpack_public_path__ + "img/pannolino_lavabile.c28d897a.jpg";